<template>
  <Flex direction="column">
    <BaseHeading>
      {{ $t('integrations.gifty.settings.key_title') }}
    </BaseHeading>
    <Flex
      v-if="!connected"
      direction="column"
    >
      <BaseText>
        {{ $t('integrations.gifty.settings.create_key') }}
      </BaseText>
      <BaseText :href="API_TOKEN_URL">
        {{ $t('integrations.gifty.settings.gifty_dashboard') }}
      </BaseText>
      <Flex :gap="0.5">
        <BaseText>
          {{ $t('integrations.gifty.settings.no_account') }}
        </BaseText>
        <BaseText :href="REGISTER_URL">
          {{ $t('integrations.gifty.settings.register') }}
        </BaseText>
      </Flex>
    </Flex>
    <Flex
      align="end"
      fullWidth
    >
      <Flex
        direction="column"
        fullWidth
      >
        <BaseInput
          :modelValue="keyLocked ? MASKED_KEY : apiToken"
          :required="!keyLocked"
          :type="keyLocked ? 'text' : 'password'"
          :label="$t('integrations.gifty.settings.api_key')"
          :error="saveFailed ? $t('integrations.gifty.settings.save_failed') : ''"
          :placeholder="$t('integrations.gifty.settings.api_key_placeholder')"
          :disabled="keyLocked"
          :focus="changingKey"
          v-test="'gifty-api-token'"
          @update:modelValue="apiToken = $event"
        />
      </Flex>
      <BaseButton
        v-if="keyLocked"
        @click="emit('changeKey')"
        v-test="'gifty-change-key'"
      >
        {{ $t('integrations.gifty.settings.change_key') }}
      </BaseButton>
      <BaseButton
        v-else-if="changingKey"
        color="inverted"
        @click="emit('keepKey')"
        v-test="'gifty-keep-key'"
      >
        {{ $t('integrations.gifty.settings.keep_key') }}
      </BaseButton>
    </Flex>
    <BaseText v-if="connected">
      {{ $t('integrations.gifty.settings.used_keys') }}
    </BaseText>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
const API_TOKEN_URL =
  'https://dashboard.gifty.nl/settings/company/developers/api';
const REGISTER_URL = 'https://dashboard.gifty.nl/register';
const MASKED_KEY = '•'.repeat(16);

defineProps<{
  changingKey: boolean;
  connected: boolean;
  keyLocked: boolean;
  saveFailed: boolean;
}>();

const emit = defineEmits(['changeKey', 'keepKey']);

const apiToken = defineModel<string>({ required: true });
</script>
